// Twetch keeps ONE device (session) key per account: signing in on another
// browser or device rotates it, and every signed write from this browser then
// fails the transport check with a bare `401 invalid signature` (twetch-4
// writes.rs) — the wallet signature was never looked at. The only recovery is
// a fresh sign-in (one wallet popup), which mints this browser a new key.

import { TwetchError } from './twetch-api'
import { loginWithWallet, type TwetchIdentity } from './twetch-auth'
import { loadDeviceKey, type DeviceKey } from './twetch-crypto'
import { useTwetch } from './twetch-store'
import { signMessageWithWallet } from './wallet-signature'

export function isStaleSessionRefusal(e: unknown): boolean {
	return e instanceof TwetchError && e.status === 401 && /invalid signature/i.test(e.message)
}

export const STALE_SESSION_MESSAGE =
	'Your Twetch session was replaced by a sign-in on another device. Sign in again to continue.'

/// Forget the stale session and sign back in with the connected wallet.
export async function recoverStaleSession(
	address: string
): Promise<{ identity: TwetchIdentity; deviceKey: DeviceKey }> {
	useTwetch.getState().signOut()
	const identity = await loginWithWallet({ address, signMessage: signMessageWithWallet })
	useTwetch.getState().setIdentity(identity)
	const deviceKey = loadDeviceKey()
	if (!deviceKey) throw new Error('Twetch could not open a session for this wallet.')
	return { identity, deviceKey }
}
